import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    float: "right"
  },
  formControl: {
    minWidth: "100%"
  },
  mBottom: {
    marginBottom: "20px"
  },
  mTop: {
    marginTop: "5px"
  },
  button: {
    margin: theme.spacing(3, 0, 2)
  }
}));

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

export default function Autobiography() {
  const classes = useStyles();
  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <Grid item xs={12} className={classes.mBottom}>
            <Typography>
              {" "}
              GIVE AN AUTOBIOGRAPHY IN ESSAY FORM IN NOT LESS THAN 3
              TYPE-WRITTEN PAGES LONG. THE FOLLOWING POINTS ARE TO BE INCLUDED:{" "}
            </Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <List component="nav" aria-label="secondary mailbox folders">
                <ListItem button>
                  <ListItemText primary="1) Your childhood -the places where you grew up." />
                </ListItem>
                <ListItemLink href="#">
                  <ListItemText primary="2) Your school years -where you schooled, any changes, if any, and why." />
                </ListItemLink>
                <ListItem button>
                  <ListItemText primary="3) Your past and present work experience." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="4) A detailed account of how you felt that God might be calling you to this life." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="5) Your relationship with God, your prayer life and experience of spiritual direction." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="6) Correspondence or experience with other religious congregations or in a seminary." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="7 ) What you understand to be the most important points in religious life and the differences between religious life and diocesan priesthood." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="8) Why you chose The Capuchins among other congregations." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="9) Your participation in parish activities and societies." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="10) Your family -all members and their occupations." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="11) Your health and your character." />
                </ListItem>

                <ListItem button>
                  <ListItemText primary="13) Your hobbies and travels." />
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="surname"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id="submit_essay"
                InputLabelProps={{ shrink: true }}
                label="Submit essay"
                type="file"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>
                NAME AND ADDRESS OF THE PARISH PRIEST OF YOUR HOME TOWN
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="name"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id=""
                label="Enter Name"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="address"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id=""
                label="Enter Address"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>
                NAME AND ADDRESS OF THE PARISH PRIEST OF YOUR PARISH OF
                RESIDENCE
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="surname"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id="submit_essay"
                label="Enter Name and address"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="address"
                name="surname"
                variant="outlined"
                required
                fullWidth
                id=""
                label="Enter Address"
              />
            </Grid>
          </Grid>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to="occupation"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            component={Link}
            to="user"
          >
            Next
          </Button>
        </form>
      </div>
    </Container>
  );
}
